import {Button, ButtonType, InputField} from '../index';
import React, {useState} from 'react';
import './OfferingContent.scss';
import {getAdjustedPrice, getPrice} from '../../utilities';
import {Gallery} from "react-grid-gallery";
import Image from '../Image';
import draftToHtml from 'draftjs-to-html';
import {convertFromRaw, convertToRaw, EditorState} from 'draft-js';
import {useAppStore} from "../../data/AppStore";
import {shallow} from "zustand/shallow";

const LOG_PREFIX = '[OfferingContentChild.js]';

const OfferingContentChild = ({offering, callback, className, images, inCart}) => {
    const [mandatoryEnteredUnit, setMandatoryEnteredUnit] = useState(0);
    const [COMPANY, CLIENT] = useAppStore((state) => [state.COMPANY, state.CLIENT], shallow)

    return (
        <div className={`Variant ${inCart ? 'inCart' : ''}`} key={offering.id}>
            <div className={'OfferingContent-header-title'}>
                {
                    (offering.json_data && offering.json_data.nickname) ?
                        offering.json_data.nickname :
                        offering.sales_option
                }
            </div>
            <div>

                <div>

                    {offering.sticker && (
                        <div className={'OfferingSticker'}>
                            <Image src={offering.sticker} fallbackSrc={null}/>
                        </div>
                    )}

                    {offering.points && (
                        <div
                            className={'OfferingPoints'}
                            dangerouslySetInnerHTML={{__html: draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(offering.points)).getCurrentContent()))}}
                        />
                    )}
                </div>

                <div className={'OfferingGallery'}>
                    {images && (
                        <Gallery images={images} enableImageSelection={false}/>
                    )}
                </div>
                <div className={'VariantButton'}>
                    {
                        ((offering.unit_type === 'l/ft') || (offering.unit_type === 'sq/ft')) ?
                            <>
                                <InputField
                                    horizontalLayout={true}
                                    label={'Qty'}
                                    onChange={(e) => {
                                        setMandatoryEnteredUnit(e.replace(/^0+/, ''));
                                    }}
                                    value={mandatoryEnteredUnit}
                                    type={'number'}
                                    min={0}
                                    clearIcon={false}
                                    placeholder={0}
                                />
                                <Button
                                    disabled={mandatoryEnteredUnit <= 0}
                                    className={className}
                                    onClick={() => callback(mandatoryEnteredUnit)}
                                    label={`${inCart ? 'Added' : 'Add'} ${getPrice(getAdjustedPrice(offering, CLIENT, COMPANY))} (${offering.unit_type})`}
                                    type={ButtonType.Add}
                                />
                            </>
                            :
                            <Button
                                className={className}
                                onClick={callback}
                                label={`${inCart ? 'Added' : 'Add'} ${getPrice(getAdjustedPrice(offering, CLIENT, COMPANY))} (${offering.unit_type})`}
                                type={ButtonType.Add}
                            />
                    }
                </div>
            </div>
        </div>
    );
}

export default OfferingContentChild;